module.exports = __webpack_public_path__ + "media/images/vp/icon.leftarrow2.white-5da3523397c4a064f937f25f8abe7b22.svg";